/*
  Subscribing someone who fills in an enquiry form.

  ---

  WHY THIS IS NOT JUST A FIELD ON THE FORM.

  Shopify's `{% form 'contact' %}` emails the merchant and does nothing else: no customer
  record, no marketing consent, no list. `{% form 'customer' %}` is the opposite — it
  creates a customer with `accepts_marketing: true` (documented at
  shopify.dev/docs/storefronts/themes/customer-engagement/email-consent) but carries no
  message body, so it cannot deliver an enquiry.

  There is no form type that does both, and an enquiry form is the warmest lead on the
  site — somebody typing "wedding, June, 120 guests" is worth a great deal more than a
  footer signup. Before this, every one of them arrived as an email and reached no list at
  all; if nobody replied by hand, the lead was simply gone.

  So the enquiry posts normally and, when the visitor ticks the box, a second request
  quietly creates the customer. Both endpoints are `/contact`; only `form_type` differs.

  ---

  WHY IT CAN NEVER BREAK THE ENQUIRY.

  The enquiry is the thing that matters and the subscribe is a bonus, so the order of
  operations is deliberate: the handler never calls `preventDefault`, never awaits, and is
  wrapped whole in a try/catch. If the subscribe request fails, is blocked, or is thrown
  away mid-navigation, the enquiry still submits exactly as it did before and the visitor
  sees no difference.

  `keepalive` is what gives the request a chance at all — the page is navigating away the
  instant this returns, and a normal fetch would be cancelled. Its 64 KB body cap is not a
  concern for an email address.

  Failure here is silent BY DESIGN. There is nothing useful to tell someone whose enquiry
  went through but whose newsletter signup did not, and a scary message on a successful
  enquiry would be worse than the missed subscription.
*/

(function () {
  if (window.__keepsetOptin) return;
  window.__keepsetOptin = true;

  // Delegated, so it covers every enquiry form on the page and any rendered later by the
  // theme editor, and binds exactly once however many times the snippet is included.
  document.addEventListener(
    'submit',
    function (event) {
      try {
        var form = event.target;
        if (!form || form.tagName !== 'FORM') return;

        var box = form.querySelector('[data-ks-optin]');
        if (!box || !box.checked) return;

        // Guard against a double submit re-subscribing the same address.
        if (box.dataset.ksSent === '1') return;

        // Named field first: `contact[email]` is the one Shopify treats as the sender, so
        // it is the one that should end up on the list even if the form ever grows a second
        // email input for something else.
        var email =
          form.querySelector('input[name="contact[email]"]') ||
          form.querySelector('input[type="email"]');
        var address = email && email.value ? email.value.trim() : '';
        if (!address || address.indexOf('@') < 1) return;

        box.dataset.ksSent = '1';

        var body = new URLSearchParams();
        body.set('form_type', 'customer');
        body.set('utf8', '✓');
        body.set('contact[email]', address);

        // Tagged with where they came from, because "asked about a wedding" and "wanted
        // market dates" are different enough that they should not get the same emails.
        var source = box.getAttribute('data-ks-optin') || '';
        body.set('contact[tags]', source ? 'newsletter,' + source : 'newsletter');

        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString(),
          keepalive: true,
        }).catch(function () {
          /* See the header: the enquiry is what matters. */
        });
      } catch (error) {
        /* Never let this stop a form submitting. */
      }
    },
    true
  );
})();
